// Quick-add do new-product-card.
// - Produto com 1 variante: adiciona direto ao carrinho.
// - Produto com variantes: abre <npc-quick-add-modal> com o seletor (?view=npc-quick-add → sections/npc-quick-add.liquid).
// Usa delegação de eventos para funcionar em cards carregados via AJAX (filtros, carrosséis, ?view=card).
(function () {
  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const MOBILE_QUERY = window.matchMedia('(max-width: 768px)');

  function formatMoney(cents, format) {
    const value = Number(cents) / 100;
    const fmt = format || 'R$ {{amount_with_comma_separator}}';
    const withDelimiters = (number, decimals, thousands, decimal) => {
      const [int, dec] = number.toFixed(decimals).split('.');
      const intFormatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dec ? `${intFormatted}${decimal}${dec}` : intFormatted;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount':
          return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals':
          return withDelimiters(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(value, 0, '.', ',');
        case 'amount_with_comma_separator':
        default:
          return withDelimiters(value, 2, '.', ',');
      }
    });
  }

  async function addToCart(variantId, quantity = 1, properties = null) {
    const body = {
      id: variantId,
      quantity,
      sections: SECTIONS,
      sections_url: window.location.pathname,
    };
    if (properties && Object.keys(properties).length) body.properties = properties;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Failed to add to cart');
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && data.sections) {
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(data);
    }
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-card', cartData: data });
    }
    return data;
  }

  function setLoading(button, loading) {
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  class NpcQuickAddModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.npc-qa-modal__dialog');
      this.content = this.querySelector('[data-npc-qa-content]');
      this.cache = new Map();

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-npc-qa-close]')) this.close();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
        if (event.key === 'Tab') this.trapFocus(event);
      });
      this.setupDragToClose();
    }

    async open(productUrl, opener) {
      this.opener = opener;
      this.content.innerHTML = '<div class="npc-qa-modal__loading" aria-hidden="true"></div>';
      this.dialog.scrollTop = 0;
      this.dialog.style.transform = '';
      this.hidden = false;
      document.body.classList.add('npc-qa-open');
      // força reflow para a transição de entrada rodar
      void this.offsetWidth;
      this.classList.add('is-open');
      this.dialog.focus({ preventScroll: true });

      try {
        const html = await this.fetchContent(productUrl);
        if (!this.classList.contains('is-open')) return;
        this.content.innerHTML = html;
        this.setupContent();
      } catch (error) {
        console.error('Error loading quick add:', error);
        window.location.href = productUrl;
      }
    }

    close() {
      if (this.hidden || !this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.dialog.style.transform = '';
      document.body.classList.remove('npc-qa-open');
      const onEnd = () => {
        if (!this.classList.contains('is-open')) this.hidden = true;
      };
      this.dialog.addEventListener('transitionend', onEnd, { once: true });
      setTimeout(onEnd, 400);
      if (this.opener) this.opener.focus({ preventScroll: true });
    }

    // Mobile: arrastar a alça para baixo fecha o bottom sheet
    setupDragToClose() {
      const handle = this.querySelector('[data-npc-qa-drag]');
      if (!handle) return;
      let startY = null;
      let delta = 0;

      handle.addEventListener('pointerdown', (event) => {
        if (!MOBILE_QUERY.matches) return;
        startY = event.clientY;
        delta = 0;
        handle.setPointerCapture(event.pointerId);
        this.dialog.classList.add('is-dragging');
      });
      handle.addEventListener('pointermove', (event) => {
        if (startY === null) return;
        delta = Math.max(0, event.clientY - startY);
        this.dialog.style.transform = `translateY(${delta}px)`;
      });
      const end = () => {
        if (startY === null) return;
        startY = null;
        this.dialog.classList.remove('is-dragging');
        if (delta > 80) {
          this.close();
        } else {
          this.dialog.style.transform = '';
        }
      };
      handle.addEventListener('pointerup', end);
      handle.addEventListener('pointercancel', end);
    }

    async fetchContent(productUrl) {
      if (this.cache.has(productUrl)) return this.cache.get(productUrl);
      const url = new URL(productUrl, window.location.origin);
      // Template product.npc-quick-add.json (layout/npc-quick-add.liquid): a section do modal + app embeds
      url.searchParams.set('view', 'npc-quick-add');
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      // Extrai apenas o conteúdo do modal, mesmo que a resposta venha com a página inteira
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('.npc-qa');
      if (!content) throw new Error('Quick add content not found');
      this.injectPersonalization(doc, content);
      const html = content.outerHTML;
      this.cache.set(productUrl, html);
      return html;
    }

    // Copia os campos do app PC Product Options (personalização) do app embed para o modal.
    // Os inputs perdem o `name` (viram data-npc-qa-prop) para não vazarem para outros forms da página,
    // e as classes do app são renomeadas para o JS/CSS do app não agir sobre o modal.
    injectPersonalization(doc, content) {
      const slot = content.querySelector('[data-npc-qa-personalization]');
      const fieldsSlot = content.querySelector('[data-npc-qa-personalization-fields]');
      if (!slot || !fieldsSlot) return;

      const productId = content.dataset.productId;
      const selector = `.product-customizer-options[data-product-id="${productId}"] .product-customizer-content`;
      let source = doc.querySelector(selector);
      if (!source) {
        // O app embed guarda o snippet num <template>, às vezes com o markup escapado como texto
        const holder = doc.getElementById('pc-app-embed-codeholder');
        if (!holder) return;
        const inner = new DOMParser().parseFromString(holder.innerHTML, 'text/html');
        source =
          inner.querySelector(selector) ||
          new DOMParser().parseFromString(inner.body.textContent || '', 'text/html').querySelector(selector);
      }
      const options = source ? Array.from(source.querySelectorAll('.product-customizer-option')) : [];
      if (!options.length) return;

      const supported = ['option-type-text', 'option-type-multiline', 'option-type-select'];
      const canRender = options.every((option) => supported.some((type) => option.classList.contains(type)));

      if (!canRender) {
        // Tipos que dependem do JS do app (upload, data, swatch...): personalização só na PDP
        slot.dataset.npcQaPersonalizationPdp = '';
        fieldsSlot.innerHTML = '<p class="npc-qa__personalization-pdp">Personalize este produto na página do produto.</p>';
        slot.querySelector('[data-npc-qa-terms]')?.remove();
        slot.hidden = false;
        return;
      }

      options.forEach((option) => {
        const clone = option.cloneNode(true);
        clone.querySelectorAll('script, style').forEach((el) => el.remove());
        [clone, ...clone.querySelectorAll('[class]')].forEach((el) => {
          const name = el.getAttribute('class');
          el.setAttribute('class', name.replace(/product-customizer-/g, 'npc-qa-pc-'));
        });
        clone.querySelectorAll('[id]').forEach((el) => (el.id = `npcqa-${el.id}`));
        clone.querySelectorAll('label[for]').forEach((el) => el.setAttribute('for', `npcqa-${el.getAttribute('for')}`));
        clone.querySelectorAll('input, textarea, select').forEach((field) => {
          const match = /^properties\[(.+)\]$/.exec(field.getAttribute('name') || '');
          if (match) field.dataset.npcQaProp = match[1];
          field.removeAttribute('name');
        });
        fieldsSlot.appendChild(clone);
      });
      slot.hidden = false;
    }

    setupContent() {
      const root = this.content.querySelector('.npc-qa');
      if (!root) return;

      this.root = root;
      this.variants = JSON.parse(root.querySelector('[data-npc-qa-variants]').textContent);
      this.strings = JSON.parse(root.querySelector('[data-npc-qa-strings]').textContent);
      this.submit = root.querySelector('[data-npc-qa-submit]');
      this.submitAvailable = !this.submit.disabled;
      this.qtyInput = root.querySelector('[data-npc-qa-qty-input]');
      this.gallery = root.querySelector('[data-npc-qa-gallery]');
      this.guide = root.querySelector('[data-npc-qa-guide]');

      root.querySelectorAll('.npc-qa__value').forEach((button) => {
        button.addEventListener('click', () => this.selectValue(button));
      });
      root.querySelectorAll('[data-npc-qa-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = (parseInt(this.qtyInput.value, 10) || 1) + Number(button.dataset.npcQaQty);
          this.qtyInput.value = Math.max(1, next);
        });
      });
      this.qtyInput.addEventListener('change', () => {
        this.qtyInput.value = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
      });
      this.submit.addEventListener('click', () => this.onSubmit());

      root.querySelector('[data-npc-qa-guide-open]')?.addEventListener('click', () => this.toggleGuide(true));
      root.querySelector('[data-npc-qa-guide-close]')?.addEventListener('click', () => this.toggleGuide(false));

      this.setupPersonalization();
      this.setupDots();
      this.renderViewers();
      this.updateAvailability();
    }

    setupPersonalization() {
      this.personalization = this.root.querySelector('[data-npc-qa-personalization]:not([hidden])');
      if (!this.personalization) return;
      this.personalizationPdp = 'npcQaPersonalizationPdp' in this.personalization.dataset;

      // Limite de caracteres: opção "CARACTERES MÁXIMO" da variante (como na PDP) ou maxlength do app
      const maxOption = this.root.querySelector('[data-npc-qa-max-chars] .npc-qa__value.is-selected');
      const optionMatch = maxOption && maxOption.dataset.optionValue.match(/\d+/);

      this.personalization.querySelectorAll('input[type="text"], textarea').forEach((field) => {
        const limit = (optionMatch && parseInt(optionMatch[0], 10)) || parseInt(field.getAttribute('maxlength'), 10);
        if (limit) field.setAttribute('maxlength', String(limit));
        if (!field.getAttribute('placeholder')) field.setAttribute('placeholder', 'Insira o nome');

        const label = field.closest('.npc-qa-pc-option')?.querySelector('label');
        if (limit && label && !label.querySelector('.npc-qa__max-hint')) {
          const hint = document.createElement('span');
          hint.className = 'npc-qa__max-hint';
          hint.textContent = `(Máximo ${String(limit).padStart(2, '0')} caracteres)`;
          label.appendChild(hint);
        }
      });

      this.personalization.addEventListener('input', () => this.setPersonalizationError(false));
      this.personalization.addEventListener('change', () => this.setPersonalizationError(false));
    }

    setPersonalizationError(show) {
      this.personalization?.classList.toggle('has-error', show);
      const error = this.personalization?.querySelector('[data-npc-qa-terms-error]');
      if (error) error.hidden = !show;
    }

    // Mesmas regras da PDP (assets/product-custom.js): texto preenchido + aceite dos termos.
    // Retorna as properties do line item, ou null se faltar algo.
    getPersonalizationProperties() {
      if (!this.personalization) return {};

      const properties = {};
      let valid = true;
      this.personalization.querySelectorAll('[data-npc-qa-prop]').forEach((field) => {
        const value = field.value.trim();
        if (!value && field.matches('input[type="text"], textarea')) valid = false;
        if (value) properties[field.dataset.npcQaProp] = value;
      });

      const terms = this.personalization.querySelector('[data-npc-qa-terms-checkbox]');
      if (terms && !terms.checked) valid = false;

      if (!valid) {
        this.setPersonalizationError(true);
        this.personalization.querySelector('[data-npc-qa-prop]')?.focus();
        return null;
      }

      properties.is_customized = 'on';
      properties['_Aceite dos termos'] = new Date().toLocaleString('pt-BR');
      return properties;
    }

    toggleGuide(show) {
      if (!this.guide) return;
      this.guide.hidden = !show;
      if (show) {
        this.dialog.scrollTop = 0;
        this.guide.scrollTop = 0;
        this.guide.querySelector('[data-npc-qa-guide-close]').focus({ preventScroll: true });
      } else {
        this.root.querySelector('[data-npc-qa-guide-open]')?.focus({ preventScroll: true });
      }
    }

    setupDots() {
      const dots = Array.from(this.root.querySelectorAll('.npc-qa__dot'));
      if (!dots.length) return;
      const update = () => {
        const slide = this.gallery.querySelector('.npc-qa__slide');
        if (!slide) return;
        const step = slide.offsetWidth + 8;
        const atEnd = this.gallery.scrollLeft + this.gallery.clientWidth >= this.gallery.scrollWidth - 2;
        const index = atEnd ? dots.length - 1 : Math.round(this.gallery.scrollLeft / step);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };
      this.gallery.addEventListener('scroll', update, { passive: true });
    }

    renderViewers() {
      const target = this.root.querySelector('[data-npc-qa-viewers]');
      if (!target) return;
      const min = Number(this.root.dataset.viewersMin) || 0;
      const max = Math.max(min, Number(this.root.dataset.viewersMax) || min);
      target.textContent = Math.floor(Math.random() * (max - min + 1)) + min;
    }

    selectedOptions() {
      return Array.from(this.root.querySelectorAll('.npc-qa__option')).map(
        (fieldset) => fieldset.querySelector('.npc-qa__value.is-selected')?.dataset.optionValue
      );
    }

    selectValue(button) {
      const fieldset = button.closest('.npc-qa__option');
      fieldset.querySelectorAll('.npc-qa__value').forEach((el) => {
        el.classList.toggle('is-selected', el === button);
        el.setAttribute('aria-pressed', el === button ? 'true' : 'false');
      });
      this.updateVariant();
    }

    updateVariant() {
      const selected = this.selectedOptions();
      const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
      const label = this.submit.querySelector('[data-npc-qa-submit-label]');

      this.submitAvailable = Boolean(variant && variant.available);

      if (!variant) {
        this.submit.disabled = true;
        label.textContent = this.strings.unavailable;
        this.updateAvailability();
        return;
      }

      this.submit.dataset.variantId = variant.id;
      this.submit.disabled = !variant.available;
      label.textContent = variant.available ? this.strings.addToCart : this.strings.soldOut;

      const sku = this.root.querySelector('[data-npc-qa-sku]');
      if (sku) {
        sku.textContent = variant.sku || '';
        this.root.querySelector('[data-npc-qa-sku-wrapper]').hidden = !variant.sku;
      }

      this.renderPrice(variant);
      this.renderCashback(variant);
      this.scrollToMedia(variant.media_id);
      this.updateAvailability();
    }

    scrollToMedia(mediaId) {
      if (!mediaId || !this.gallery) return;
      const slide = this.gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (!slide) return;
      const vertical = !MOBILE_QUERY.matches;
      this.gallery.scrollTo({
        top: vertical ? slide.offsetTop - this.gallery.offsetTop - 24 : 0,
        left: vertical ? 0 : slide.offsetLeft - this.gallery.offsetLeft - 16,
        behavior: 'smooth',
      });
    }

    renderPrice(variant) {
      const { promoPercentage, moneyFormat } = this.root.dataset;
      const promo = Number(promoPercentage) || 0;
      const money = (cents) => formatMoney(cents, moneyFormat);
      let finalPrice = variant.price;
      let html;

      if (promo > 0) {
        finalPrice = Math.floor((variant.price * (100 - promo)) / 100);
        html = `<span class="npc-qa__price-compare">${money(variant.price)}</span><span class="npc-qa__price-current">${money(finalPrice)}</span>`;
      } else if (variant.compare_at_price > variant.price) {
        html = `<span class="npc-qa__price-compare">${money(variant.compare_at_price)}</span><span class="npc-qa__price-current">${money(variant.price)}</span>`;
      } else {
        html = `<span class="npc-qa__price-current">${money(variant.price)}</span>`;
      }
      this.root.querySelector('[data-npc-qa-price]').innerHTML = html;
      this.renderInstallments(finalPrice);
    }

    // Espelha snippets/product-installments.liquid
    renderInstallments(price) {
      const container = this.root.querySelector('[data-npc-qa-installments]');
      const d = this.root.dataset;
      container.innerHTML = '';
      if (d.installmentsEnable !== 'true' || price < Number(d.installmentsMinOrder)) return;

      const max = Math.min(Math.floor(price / Number(d.installmentsMinValue)), Number(d.installmentsMax));
      if (!(max >= 1)) return;

      const label = d.installmentsText
        .replace('{count}', max)
        .replace('{price}', formatMoney(Math.floor(price / max), d.moneyFormat));
      const p = document.createElement('p');
      p.className = 'price-installments';
      p.textContent = `ou ${label}`;
      container.appendChild(p);
    }

    // Espelha o bloco "cashback" da PDP (porcentagem sobre o preço da variante)
    renderCashback(variant) {
      const target = this.root.querySelector('[data-npc-qa-cashback]');
      if (!target || this.root.dataset.cashbackType !== 'percentage') return;
      const value = Number(this.root.dataset.cashbackValue) || 0;
      target.textContent = formatMoney(Math.floor((variant.price * value) / 100), this.root.dataset.moneyFormat);
    }

    // Marca valores que não formam uma variante disponível com as demais opções selecionadas
    updateAvailability() {
      const selected = this.selectedOptions();
      this.root.querySelectorAll('.npc-qa__option').forEach((fieldset, index) => {
        fieldset.querySelectorAll('.npc-qa__value').forEach((button) => {
          const candidate = [...selected];
          candidate[index] = button.dataset.optionValue;
          const available = this.variants.some(
            (v) => v.available && v.options.every((value, i) => value === candidate[i])
          );
          button.classList.toggle('is-unavailable', !available);
        });
      });
    }

    async onSubmit() {
      const variantId = this.submit.dataset.variantId;
      if (!variantId || this.submit.disabled) return;
      if (this.personalizationPdp) {
        window.location.href = this.root.querySelector('.npc-qa__link').href;
        return;
      }
      const properties = this.getPersonalizationProperties();
      if (!properties) return;

      const quantity = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
      setLoading(this.submit, true);
      try {
        await addToCart(variantId, quantity, properties);
        this.close();
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert(error.message || 'Erro ao adicionar produto ao carrinho. Tente novamente.');
      } finally {
        setLoading(this.submit, false);
        this.submit.disabled = !this.submitAvailable;
      }
    }

    trapFocus(event) {
      const focusable = Array.from(
        this.dialog.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('npc-quick-add-modal')) {
    customElements.define('npc-quick-add-modal', NpcQuickAddModal);
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.npc-quick-add');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const modal = document.querySelector('npc-quick-add-modal');
    if (button.dataset.hasVariants === 'true') {
      if (modal) modal.open(button.dataset.productUrl, button);
      else window.location.href = button.dataset.productUrl;
      return;
    }

    if (button.disabled) return;
    setLoading(button, true);
    try {
      await addToCart(button.dataset.variantId);
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(error.message || 'Erro ao adicionar produto ao carrinho. Tente novamente.');
    } finally {
      setLoading(button, false);
    }
  });
})();
